"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_if_1 = require("react-if");
const react_loops_1 = require("react-loops");
const react_moment_1 = tslib_1.__importDefault(require("react-moment"));
const CenteredRow_1 = require("../../../comps/reusables/CenteredRow");
const CreateResourcesButton_1 = require("../../../comps/reusables/CreateResourcesButton");
const react_2 = require("@osmosys/react");
const WorkflowDynamicLogo_1 = require("./WorkflowDynamicLogo");
const svg_1 = require("../../../svg");
const graphql_1 = require("../../../graphql");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const WorkflowRunsMini = ({ workflowId }) => {
    const result = react_hooks_1.useQuery(graphql_1.workflowRuns, {
        variables: {
            orderBy: 'runDateTime',
            orderDir: 'ASC',
            take: 3,
            workflowId,
        },
    });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_loops_1.For, { of: result.data ? result.data.workflowRuns : [], ifEmpty: react_1.default.createElement("div", null, "No runs scheduled"), as: (item, { index }) => {
                return (react_1.default.createElement(CenteredRow_1.CenteredRow, { key: index }, [
                    react_1.default.createElement("div", { className: "p-2", key: 1 },
                        react_1.default.createElement(WorkflowDynamicLogo_1.WorkflowDynamicLogo, { status: item.status, width: "32", height: "32" })),
                    {
                        grow: true,
                        render: (react_1.default.createElement("div", { className: "text-left" },
                            react_1.default.createElement(react_if_1.Switch, null,
                                react_1.default.createElement(react_if_1.Case, { condition: item.status === 'scheduled' },
                                    "Running ",
                                    react_1.default.createElement(react_moment_1.default, { fromNow: true }, item.runDateTime)),
                                react_1.default.createElement(react_if_1.Case, { condition: item.status === 'pendingApproval' }, "Pending approval"),
                                react_1.default.createElement(react_if_1.Case, { condition: item.status === 'proofSentNoApprovalNeeded' }, "Proof sent"),
                                react_1.default.createElement(react_if_1.Case, { condition: item.status === 'running' }, "Sending..."),
                                react_1.default.createElement(react_if_1.Case, { condition: item.status === 'cancelled' }, "Cancelled"),
                                react_1.default.createElement(react_if_1.Case, { condition: item.status === 'paused' }, "Paused")))),
                    },
                ]));
            } })));
};
exports.WorkflowsList = () => {
    const router = use_react_router_1.default();
    return (react_1.default.createElement(react_2.OsmosysListLayout, { itemProps: (item) => {
            return {
                body: react_1.default.createElement(WorkflowRunsMini, { workflowId: item.id }),
                icon: react_1.default.createElement(svg_1.WorkflowsLogo, { width: "80", height: "80" }),
                iconLabel: 'Workflow',
                linkURL: `/workflows/${item.id}`,
                meta: `Created ${moment_1.default(item.createdAt).format('LLL')}`,
                title: item.name,
            };
        }, pathToCount: "workflowsCount", pathToItems: "workflows", pathToLabel: "name", itemName: "workflow", itemsName: "workflows", toolbarLeft: () => (react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(CreateResourcesButton_1.CreateResourcesButton, { label: "New workflow", modalProps: {
                    formProps: {
                        formikProps: {
                            initialValues: {
                                name: '',
                            },
                        },
                        mutationProps: {
                            mutation: graphql_1.createWorkflow,
                            onCompleted: d => {
                                router.history.push(`/workflows/${d.createWorkflow.id}`);
                            },
                        },
                        valuesToVariables: values => {
                            return {
                                data: {
                                    name: values.name,
                                },
                            };
                        },
                    },
                    header: 'New workflow',
                } }),
            ' ')), showReloadButton: true, query: {
            query: graphql_1.workflows,
        } }));
};
exports.default = exports.WorkflowsList;
//# sourceMappingURL=index.js.map